/**
 * Admin Theme Initializer
 * Applies saved theme preferences from localStorage immediately on page load
 * This prevents flash of unstyled content (FOUC)
 */

export const initializeAdminTheme = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  try {
    const savedAccent = localStorage.getItem('adminAccent') || 'blue';
    const savedTheme = localStorage.getItem('adminTheme') || 'light';

    document.documentElement.setAttribute('data-admin-theme', savedTheme);
    document.documentElement.setAttribute('data-admin-accent', savedAccent);
  } catch (error) {
    // localStorage may be blocked in some browsers
    console.warn('Could not load admin theme preferences:', error);
    document.documentElement.setAttribute('data-admin-theme', 'light');
    document.documentElement.setAttribute('data-admin-accent', 'blue');
  }
};

export const setAdminTheme = (theme) => {
  if (typeof window === 'undefined') return;
  
  localStorage.setItem('adminTheme', theme);
  document.documentElement.setAttribute('data-admin-theme', theme);
};

export const setAdminAccent = (accent) => {
  if (typeof window === 'undefined') return;
  
  localStorage.setItem('adminAccent', accent);
  document.documentElement.setAttribute('data-admin-accent', accent);
};

export const getAdminTheme = () => {
  if (typeof window === 'undefined') return 'light';
  return localStorage.getItem('adminTheme') || 'light';
};

export const getAdminAccent = () => {
  if (typeof window === 'undefined') return 'blue';
  return localStorage.getItem('adminAccent') || 'blue';
};
